module.exports = __webpack_public_path__ + "static/media/potrait.6efc1993.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/potrait.png
// module id = 210
// module chunks = 0